/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountHasLegacyBillingDetailsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountHasLegacyBillingDetailsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly hasLegacyBillingDetails: boolean, readonly id: CK.AccountId } | null };


export const AccountHasLegacyBillingDetailsDocument = gql`
    query AccountHasLegacyBillingDetails($accountId: AccountId!) {
  account(id: $accountId) {
    hasLegacyBillingDetails
    id
  }
}
    `;

/**
 * __useAccountHasLegacyBillingDetailsQuery__
 *
 * To run a query within a React component, call `useAccountHasLegacyBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountHasLegacyBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountHasLegacyBillingDetailsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountHasLegacyBillingDetailsQuery(baseOptions: Apollo.QueryHookOptions<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables> & ({ variables: AccountHasLegacyBillingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables>(AccountHasLegacyBillingDetailsDocument, options);
      }
export function useAccountHasLegacyBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables>(AccountHasLegacyBillingDetailsDocument, options);
        }
export function useAccountHasLegacyBillingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables>(AccountHasLegacyBillingDetailsDocument, options);
        }
export type AccountHasLegacyBillingDetailsQueryHookResult = ReturnType<typeof useAccountHasLegacyBillingDetailsQuery>;
export type AccountHasLegacyBillingDetailsLazyQueryHookResult = ReturnType<typeof useAccountHasLegacyBillingDetailsLazyQuery>;
export type AccountHasLegacyBillingDetailsSuspenseQueryHookResult = ReturnType<typeof useAccountHasLegacyBillingDetailsSuspenseQuery>;
export type AccountHasLegacyBillingDetailsQueryResult = Apollo.QueryResult<AccountHasLegacyBillingDetailsQuery, AccountHasLegacyBillingDetailsQueryVariables>;